type EnvKey = "VITE_ADMIN_API_BASE_URL" | "VITE_ADMIN_WS_BASE_URL";

const readRequiredEnv = (key: EnvKey): string => {
	const value = import.meta.env[key]?.trim();
	if (!value) {
		throw new Error(`${key} is required`);
	}
	if (value.endsWith("/")) {
		throw new Error(`${key} must not end with a trailing slash`);
	}
	return value;
};

const readAbsoluteBaseUrl = (
	key: EnvKey,
	allowedProtocols: readonly string[],
	requiredPathname: string,
): string => {
	const value = readRequiredEnv(key);
	let url: URL;

	try {
		url = new URL(value);
	} catch {
		throw new Error(`${key} must be an absolute URL`);
	}

	if (!allowedProtocols.includes(url.protocol)) {
		throw new Error(`${key} must use one of: ${allowedProtocols.join(", ")}`);
	}
	if (url.pathname !== requiredPathname) {
		throw new Error(`${key} must end exactly with ${requiredPathname}`);
	}
	if (url.search || url.hash || url.username || url.password) {
		throw new Error(`${key} must not include credentials, query string, or hash`);
	}

	return value;
};

export const ADMIN_API_BASE_URL = readAbsoluteBaseUrl(
	"VITE_ADMIN_API_BASE_URL",
	["http:", "https:"],
	"/api",
);

export const ADMIN_WS_BASE_URL = readAbsoluteBaseUrl(
	"VITE_ADMIN_WS_BASE_URL",
	["ws:", "wss:"],
	"/ws",
);
